import React, { useEffect, useState } from "react";
import ContainerService from "../../components/container-service/ContainerService";
import { Link } from "react-router-dom";
import Axios from "axios";
import { urlAPI } from '../../utils/config';
import { isActive, getToken, getUser } from '../../utils/validations';
import { data, event } from "jquery";
import { Chart } from "chart.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import ModalFirstPsico from "../../components/modal/ModalFirstPsico";
import Swal from "sweetalert2";
import iconCheck from "../../assets/img/ic-check-green.svg";
import iconFail from "../../assets/img/img_test_psico/firstTest/error.svg";
import iconClock from "../../assets/img/bancolombia-ico-reloj.svg";
import { useHistory } from 'react-router-dom';
import * as ChartDatalabels from 'chartjs-plugin-datalabels';
import Loader from "../../components/loader/Loader";
import { OverlayTrigger,Popover } from 'react-bootstrap';
import './psicoStyle.css'



export default function PsicoTest(props) {
    let [cont, setCont] = useState(1);
    let [step, setStep] = useState(0);
    let [pruebas, setPruebas] = useState(true);
    let [dataTypePsico, setdataTypePsico] = useState([]);
    let [dataQuestions, setdataQuestions] = useState([]);
    let [formAnswers, setFormAnswers] = useState([]);
    let [nameTest, setnameTest] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalType, setModalType] = useState(false);
    const [contador, setContador] = useState([])
    const [jsonFiltro, setJsonFiltro] = useState([])
    const [gestion, setGestion] = useState(false)
    const history = useHistory()
    const [loaderShow, setLoaderShow] = useState(false);

    const jsonMes = [
        { id: 1, value: 'p-partes' },
        { id: 2, value: 'p-numeros' },
        { id: 5, value: 'p-razonamiento' },
        { id: 6, value: 'p-percepcion' },
        { id: 3, value: 'p-estilo-gestion' },
        { id: 4, value: 'p-liderazgo' }
    ]

    useEffect(() => {
        getTypePsico()
        Chart.plugins.unregister(ChartDatalabels);
    }, []);

    const startprueba =()=>{
        if (window.location.pathname !=="/s/desempleo/preparar-entrevistas/pruebas" && 
        window.location.pathname !=="/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/resultados") {
            
            if (isActive()) {
              Swal.fire({
                  imageUrl: iconClock,
                  title: 'Tiempo finalizado',
                  text: 'Se ha terminado el tiempo para la realización de la prueba. ',
                  confirmButtonText: 'ACEPTAR',
                  customClass: 'SwalFinalizar1',
                  allowOutsideClick: false,
                  showCloseButton: true

              }).then((result) => {
                    setdataQuestions([]);
                      backPage()
                      window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas')
              })
            }
        }
    }

    const getTypePsico = () => {
        Axios.get(`${urlAPI}/PruebasSicotecnicas/Tipos`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
            }
        }).then(succ => {
            setdataTypePsico(succ.data);
        }).catch(error => {
            //console.log(error);
        });
    }
    let obj
    const getQuestionsComplete = (id) => {
        setLoaderShow(true);
        Axios.get(`${urlAPI}/PruebasSicotecnicas/Preguntas/prueba/${id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
            }
        }).then(succ => {
            setdataQuestions(succ.data.data);
            selected(id)
            addTest()
        }).catch(error => {
            //console.log(error);
        });
        pruebasUno()
    }
    const selected = (id) => {
        dataTypePsico.forEach(data => {
          if (data.idTipoPregunta == id) {
            obj = data;
          }
        });
    }
    const [idPrueba,setIdPrueba] = useState()
    const addTest = () => {
        let form = {
          idUsuario: getUser().idUsuario,
          idTipoPregunta: obj.idTipoPregunta,
          esSimulacion: 'prueba'
        };
    
        Axios.post(`${urlAPI}/PruebasSicotecnicas/RegistraPrueba`,form, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
            }
        }).then(succ => {
            if (succ.data.codigo == 0) {
                setIdPrueba(succ.data.data.idPrueba)
            }
            setLoaderShow(false);
        }).catch(error => {
            //console.log(error);
        });
      }
    const linkbread = [{
        to: "/auth/inicio",
        tittle: "Inicio > "
    },
    {
        to: "/s/desempleo/preparar-entrevistas/inicio",
        tittle: "Prepara tus entrevistas ",
    },
    {
        to: "/s/desempleo/preparar-entrevistas/pruebas",
        tittle: "Servicios ",
    }];
    const closeModal = () => {
        setModalShow(false);
    }
    const handleChangeRadio = (event, id) => {
        if (event.target.name == 'question1' && event.target.value == 2) {
            setModalShow(true);
            setModalType('correcta')
        } else if (event.target.name == 'question2' && event.target.value == 0) {
            setModalShow(true);
            setModalType('correcta')
        } else {
            setModalShow(true);
            setModalType('incorrecta')
        }
    }
    const PruebasOne = (id) => {
        setJsonFiltro(jsonMes.filter((x) => x.id == id).map(data => { return data.value }))
        let value = jsonMes.filter((x) => x.id == id).map(data => { return data.value })
        window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/' + value)
    }
    const pruebasUno = () => {
        if (jsonFiltro == 'p-estilo-gestion') {
            setStep(2)
            setGestion(true)
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/' + jsonFiltro + '/empezada/seccion-1')
        } else {
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/' + jsonFiltro + '/empezada')
        }
        setCont(3)
        let bitch = setTimeout(function (params) {
            startprueba()
        },300000)
    }

    const backStep = (id) => {
        if (id == 1) {
            setStep(2)
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/p-estilo-gestion/empezada/seccion-1')
        } else if (id == 2) {
            setStep(1)
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/p-estilo-gestion/empezada/seccion-2')
        } else if (id == 3) {
            setStep(0)
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/p-estilo-gestion/empezada/seccion-3')
        }
    }

    const goStep = () => {
        if (step == 2) {
            step = 1;
            document.getElementById("custom-content-below-profile-tab").click();
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/p-estilo-gestion/empezada/seccion-2')
        } else if (step == 1) {
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/p-estilo-gestion/empezada/seccion-3')
            step = 0;
            document.getElementById("custom-content-below-messages-tab").click();
        }

        window.scroll(0, 350);
    }

    let [indexInc, setIndexInc] = useState(1)
    let index = 1
    const IndexInc = () => {
        if (index > dataQuestions.length) {
            if (index > dataQuestions.length) {
                index = 1;
            }
            return index++;
        }
    }
    let conti = []
    const saveData1 = (form) => {
        Axios.post(`${urlAPI}/PruebasSicotecnicas/RegistraPregunta`, form, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
            }
        }).then(succ => {
            
            conti.push(succ)
            if (conti.length == numPrueba) {
                window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/' + jsonFiltro + '/finalizada')
                setLoaderShow(false);
                Swal.fire({
                    imageUrl: iconCheck,
                    title: 'Has finalizado la prueba con éxito',
                    text: 'Continúa con las demás pruebas.',
                    confirmButtonText: 'Selección de pruebas',
                    cancelButtonText: 'Ver mi resultado',
                    showCancelButton: true,
                    customClass: 'SwalFinalizar',
                    allowOutsideClick: false,
                    showCloseButton: true

                }).then((result) => {
                    if (result.value) {
                        backPage()
                        window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas')
                    } else {
                        document.getElementById('wRVeresult').click()
                        document.getElementById('pills-info-tab').classList.remove('active')
                        document.getElementById('pills-contact-tab').classList.add('active')
                        window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/' + jsonFiltro + '/resultados')
                    }
                })
            }

        }).catch(error => {
            setLoaderShow(false);
            //console.log(error);
        });
    }
    const [textPop,settextPop] = useState('')
    const changePop = (id) =>{
        settextPop(id == 1?'Evalúa tu capacidad para diferenciar formas y volúmenes.':id == 2?'Mide tu capacidad para dar respuesta a problemas y situaciones concretas.':id == 5?'Conoce tu capacidad para desarrollar problemas de forma lógica.':id == 6?'Mide tu capacidad para dar respuesta a problemas y situaciones concretas.':id == 3?'Conoce tus rasgos básicos de tu personalidad':'Conoce tus habilidades para ser líder.')
    }
    const popover = (
        <Popover id="popover-basic">
            <Popover.Content>
                {textPop}
            </Popover.Content>
        </Popover>
    );

    let numPrueba = 0
    const saveData = () => {
        setLoaderShow(true);
        let ps = document.getElementsByClassName("grupoPregunta");
        let todasRespondidas = true;
        numPrueba = ps.length
        let otro = []
        for (var i = 0; i < ps.length; i++) {
            let radioRespondido = false;
            let psr = document.getElementsByName("radio-" + ps[i].id.split('-')[1]);
            for (var j = 0; j < psr.length; j++) {
                if (psr[j]['checked'] == true) {
                    radioRespondido = true;
                    let form = {
                        idPrueba: idPrueba,
                        idPregunta: parseInt(ps[i].id.split('-')[1]),
                        idPreguntaRespuesta: parseInt(psr[j].id.split('-')[1])
                    }
                    setFormAnswers(formAnswers => [...formAnswers, form]);
                    otro.push(form)
                }
            }
            if (radioRespondido == false) {
                todasRespondidas = false;
            }
        }
        if (todasRespondidas) {
            setContador(0)
            
            otro.forEach((element, index) => {
                Axios.post(`${urlAPI}/PruebasSicotecnicas/RegistraPregunta`,element, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getToken(),
                    }
                }).then(succ => {
                    Axios.get(`${urlAPI}/PruebasSicotecnicas/finalizarPrueba/${succ.data.data.idPrueba}`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + getToken(),
                        }
                    }).then(succ => {
                        saveData1(element)
                    }).catch(error => {
                        //console.log(error);
                    });
                }).catch(error => {
                    //console.log(error);
                });
                
            })
            setdataQuestions([]);
            
        }else {
            setLoaderShow(false);
            Swal.fire({
                imageUrl: iconFail,
                title: 'Campos incompletos',
                text: 'Por favor diligencia todos los campos para continuar.',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Ver mi resultado',
                customClass: 'SwalFinalizarNo',
                allowOutsideClick: false,
                showCloseButton: true   
            })
              return;
        }
    }
    const [Partes_,setPartes] = useState('')
    const [Partes_buenas_,setPartes_buenas] = useState(0)
    const [Partes_malas_,setPartes_malas] = useState(0)
    let Partes
    let Partes_buenas
    let Partes_malas

    const [Razonamiento_,setRazonamiento] = useState('')
    const [Razonamiento_buenas_,setRazonamiento_buenas] = useState(0)
    const [Razonamiento_malas_,setRazonamiento_malas] = useState(0)
    let Razonamiento
    let Razonamiento_buenas
    let Razonamiento_malas

    const [Numeros_,setNumeros] = useState('')
    const [Numeros_buenas_,setNumeros_buenas] = useState(0)
    const [Numeros_malas_,setNumeros_malas] = useState(0)
    let Numeros
    let Numeros_buenos
    let Numeros_malos

    const [Percepcion_,setPercepcion] = useState('')
    const [Percepcion_buenas_,setPercepcion_buenas] = useState(0)
    const [Percepcion_malas_,setPercepcion_malas] = useState(0)
    let Percepcion
    let Percepcion_buenos
    let Percepcion_malos

    let valueCurve = false
    const cargarDatosResolucion = () => {
        if (window.innerWidth <= 425) {
            document.getElementById('divBig').classList.add('p-0')
            document.getElementById('divBig1').classList.add('p-0')
            document.getElementById('margin3').classList.replace('m-3','padd10')            
        }
        window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas/mis-pruebas/resultados')
        Axios.get(`${urlAPI}/PruebasSicotecnicas/resolucion/${getUser().idUsuario}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
            }
        }).then(res => {
            let optDona = {
                layout: { padding: { top: 25, } },
                tooltips: {
                    enabled: true,
                    backgroundColor: "#ffffff",
                    bodyFontColor: 'black',
                    titleFontColor: '#ffffff',
                    displayColors: false,
                    xPadding: 20,
                    yPadding: 20,
                    borderColor: 'rgba(0, 0, 0, 0.22)',
                }, plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            let sum = 0;
                            let dataArr = ctx.chart.data.datasets[0].data;
                            dataArr.map(data => {
                                sum += data;
                            });
                            let percentage = (value * 100 / sum).toFixed(1) + '%';
                            return percentage;
                        },
                        display: true,
                        color: ["#FFFFFF", "#58585B"],
                        font: {
                            style: 'normal',
                        },
                    },
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        padding: 20,
                    }
                },
            }
            const textosArea = ['', 'Partes', 'Números', 'Razonamiento', 'Percepción'];
            if (res.data[0].json3 != "") {

                let jsonAgilidad = JSON.parse(res.data[0].json3);
                if (jsonAgilidad.length > 0) {
                    setPartes(jsonAgilidad[0].texto)
                    setPartes_buenas(jsonAgilidad[0].buenas == "" ? "0" : jsonAgilidad[0].buenas)
                    setPartes_malas(jsonAgilidad[0].buenas == "" ? "0" : jsonAgilidad[0].malas)
                    Partes = jsonAgilidad[0].texto;
                    Partes_buenas = jsonAgilidad[0].buenas == "" ? "0" : jsonAgilidad[0].buenas;
                    Partes_malas = jsonAgilidad[0].malas == "" ? "0" : jsonAgilidad[0].malas;
                } else {
                    Partes = "";
                    Partes_buenas = "0";
                    Partes_malas = "0";
                }
                if (jsonAgilidad.length > 1) {
                    setNumeros(jsonAgilidad[1].texto)
                    setNumeros_buenas(jsonAgilidad[1].buenas == "" ? "0" : jsonAgilidad[1].buenas)
                    setNumeros_malas(jsonAgilidad[1].buenas == "" ? "0" : jsonAgilidad[1].malas)
                    Numeros = jsonAgilidad[1].texto;
                    Numeros_buenos = jsonAgilidad[1].buenas == "" ? "0" : jsonAgilidad[1].buenas;
                    Numeros_malos = jsonAgilidad[1].malas == "" ? "0" : jsonAgilidad[1].malas;
                } else {
                    Numeros = "";
                    Numeros_buenos = "0";
                    Numeros_malos = "0";
                }
                if (jsonAgilidad.length > 2) {
                    setRazonamiento(jsonAgilidad[2].texto)
                    setRazonamiento_buenas(jsonAgilidad[2].buenas == "" ? "0" : jsonAgilidad[2].buenas)
                    setRazonamiento_malas(jsonAgilidad[2].buenas == "" ? "0" : jsonAgilidad[2].malas)
                    Razonamiento = jsonAgilidad[2].texto;
                    Razonamiento_buenas = jsonAgilidad[2].buenas == "" ? "0" : jsonAgilidad[2].buenas;
                    Razonamiento_malas = jsonAgilidad[2].malas == "" ? "0" : jsonAgilidad[2].malas;
                } else {
                    Razonamiento = "";
                    Razonamiento_buenas = "0";
                    Razonamiento_malas = "0";
                }
                if (jsonAgilidad.length > 3) {
                    setPercepcion(jsonAgilidad[3].texto)
                    setPercepcion_buenas(jsonAgilidad[3].buenas == "" ? "0" : jsonAgilidad[3].buenas)
                    setPercepcion_malas(jsonAgilidad[3].buenas == "" ? "0" : jsonAgilidad[3].malas)
                    Percepcion = jsonAgilidad[3].texto;
                    Percepcion_buenos = jsonAgilidad[3].buenas == "" ? "0" : jsonAgilidad[3].buenas;
                    Percepcion_malos = jsonAgilidad[3].malas == "" ? "0" : jsonAgilidad[3].malas;
                } else {
                    Percepcion = "";
                    Percepcion_buenos = "0";
                    Percepcion_malos = "0";
                }
            }
            if (res.data[0].json1 != "") {
                let valores = [];
                let textos = [];
                
                let jsonLider = JSON.parse(res.data[0].json1);
                for (let i = 0; i < jsonLider.length; i++) {
                    valores.push(jsonLider[i].valor)
                    textos.push(jsonLider[i].tipoInfluencia)
                    if (jsonLider[i].valor > 0) {
                        valueCurve = true
                    }
                }
                let bar_ctx = document.getElementById('barChart').getContext('2d');

                let purple_orange_gradient = bar_ctx.createLinearGradient(0, 0, 0, 400);
                purple_orange_gradient.addColorStop(0, '#D1D2D3');
                purple_orange_gradient.addColorStop(1, '#9D9E9E');
                Chart.elements.Rectangle.prototype.draw = function() {
                    var ctx = this._chart.ctx;
                    var vm = this._view;
                    var left, right, top, bottom, signX, signY, borderSkipped, radius;
                    var borderWidth = vm.borderWidth;
                    var cornerRadius = 20;
                
                    if (!vm.horizontal) {
                        left = vm.x - vm.width / 2;
                        right = vm.x + vm.width / 2;
                        top = vm.y;
                        bottom = valueCurve?1000:vm.base;
                        signX = 1;
                        signY = bottom > top? 1: -1;
                        borderSkipped = vm.borderSkipped || 'bottom';
                    } else {
                        left = vm.base;
                        right = vm.x;
                        top = vm.y - vm.height / 2;
                        bottom = vm.y + vm.height / 2;
                        signX = right > left? 1: -1;
                        signY = 1;
                        borderSkipped = vm.borderSkipped || 'left';
                    }
                
                    if (borderWidth) {
                        var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
                        borderWidth = borderWidth > barSize? barSize: borderWidth;
                        var halfStroke = borderWidth / 2;
                        var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
                        var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
                        var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
                        var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
                        if (borderLeft !== borderRight) {
                            top = borderTop;
                            bottom = borderBottom;
                        }
                        if (borderTop !== borderBottom) {
                            left = borderLeft;
                            right = borderRight;
                        }
                    }
                
                    ctx.beginPath();
                    ctx.fillStyle = vm.backgroundColor;
                    ctx.strokeStyle = vm.borderColor;
                    ctx.lineWidth = borderWidth;
                    var corners = [
                        [left, bottom],
                        [left, top],
                        [right, top],
                        [right, bottom]
                    ];
                
                    var borders = ['bottom', 'left', 'top', 'right'];
                    var startCorner = borders.indexOf(borderSkipped, 0);
                    if (startCorner === -1) {
                        startCorner = 0;
                    }
                
                    function cornerAt(index) {
                        return corners[(startCorner + index) % 4];
                    }
                
                    var corner = cornerAt(0);
                    ctx.moveTo(corner[0], corner[1]);
                    var nextCornerId
                    for (var i = 1; i < 4; i++) {
                        corner = cornerAt(i);
                        nextCornerId = i+1;
                        if(nextCornerId == 4){
                            nextCornerId = 0
                        }
                
                        let nextCorner = cornerAt(nextCornerId);
                
                        let width = corners[2][0] - corners[1][0];
                        let height = corners[0][1] - corners[1][1];
                        let x = corners[1][0];
                        let y = corners[1][1];
                        
                        let radius = cornerRadius;
                        
                        if(radius > height/2){
                            radius = height/2;
                        }if(radius > width/2){
                            radius = width/2;
                        }
                
                        ctx.moveTo(x + radius, y);
                        ctx.lineTo(x + width - radius, y);
                        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                        ctx.lineTo(x + width, y + height - radius);
                        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                        ctx.lineTo(x + radius, y + height);
                        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                        ctx.lineTo(x, y + radius);
                        ctx.quadraticCurveTo(x, y, x + radius, y);
                    }
                
                    ctx.fill();
                    if (borderWidth) {
                        ctx.stroke();
                    }
                }; 
                

                let myBarChart = new Chart(bar_ctx, {
                    type: 'bar',
                    data: {
                        labels: textos,
                        datasets: [{
                            data: valueCurve?valores:0,
                            backgroundColor: purple_orange_gradient,
                            hoverBackgroundColor: purple_orange_gradient,
                            borderColor: "#026ED3",
                            borderWidth: 0,
                        }
                        ],
                    },
                    position: "top",
                    options: {
                        responsive:true,
                        maintainAspectRatio: true,
                        layout: { padding: { top: 50, left: 12, }, },
                        legend: {
                            display: false
                        },
                        tooltips: {
                            enabled: true,
                            backgroundColor: "#ffffff",
                            bodyFontColor: 'black',
                            titleFontColor: 'black',
                            displayColors: false,
                            xPadding: 20,
                            yPadding: 20,
                            borderColor: 'rgba(0, 0, 0, 0.22)',
                            borderWidth: 2
                        },
                        scales: {
                            xAxes: [{
                                categoryPercentage: 0.2,
                                gridLines: { display: false },
                            }],

                        },
                    }
                });
            }
            if (res.data[0].json1 != "") {
                var jsonLider = JSON.parse(res.data[0].json1);
                var line_ctx = document.getElementById('areaChart').getContext('2d');

                var purple_orange_gradient = line_ctx.createLinearGradient(0, 0, 0, 400);
                purple_orange_gradient.addColorStop(0, '#DBDBDB');
                purple_orange_gradient.addColorStop(1, '#FFF');
                
                let myAreaChart = new Chart(line_ctx, {
                    type: 'line',
                    data: {
                        labels: textosArea,
                        datasets: [{
                            data: [0, Partes_buenas, Numeros_buenos, Razonamiento_buenas, Percepcion_buenos],
                            backgroundColor: purple_orange_gradient,
                            hoverBackgroundColor: "#DBDBDB",
                            borderColor: "#666666",
                            borderWidth: 0,
                            lineTension: 0,
                            pointBackgroundColor: "#ffffff",
                            pointRadius: 4,
                        }
                        ],
                    },
                    position: "top",
                    options: {
                        layout: { padding: { top: 50, left: 12, }, },
                        legend: {
                            display: false
                        },
                        tooltips: {
                            enabled: true,
                            backgroundColor: "#ffffff",
                            bodyFontColor: '#808080',
                            titleFontColor: '#808080',
                            displayColors: false,
                            xPadding: 20,
                            yPadding: 20,

                            borderWidth: 2
                        },
                        scales: {
                            xAxes: [{
                                categoryPercentage: 0.2,
                                gridLines: { display: false },
                            }],

                        },
                    }
                });
            }
            if (res.data[0].json2 == "") {
                res.data[0].json2 = "[{\"orden\":1,\"glosa\":\"Extrovertido\",\"cantidad\":0},{\"orden\":1,\"glosa\":\"Introvertido\",\"cantidad\":0},{\"orden\":2,\"glosa\":\"Intuición\",\"cantidad\":0},{\"orden\":2,\"glosa\":\"Sensitivo\",\"cantidad\":0},{\"orden\":3,\"glosa\":\"Juicio\",\"cantidad\":0},{\"orden\":3,\"glosa\":\"Percepción\",\"cantidad\":0},{\"orden\":4,\"glosa\":\"Emocional\",\"cantidad\":0},{\"orden\":4,\"glosa\":\"Racional\",\"cantidad\":0}]";
            }
            if (res.data[0].json2 != "") {
                var jsonPersonalidad = JSON.parse(res.data[0].json2);
                new Chart(document.getElementById("pieChart1"), {
                    plugins: [ChartDatalabels],
                    type: 'doughnut',
                    data: {
                        labels: [jsonPersonalidad[0].glosa, jsonPersonalidad[1].glosa],
                        datasets: [{
                            data: [jsonPersonalidad[0].cantidad, jsonPersonalidad[1].cantidad],
                            backgroundColor: ["#58585B", "#e5e5e5"],
                        }
                        ],
                    },
                    options: optDona,
                });
                new Chart(document.getElementById("pieChart2"), {
                    plugins: [ChartDatalabels],
                    type: 'doughnut',
                    data: {
                        labels: [jsonPersonalidad[2].glosa, jsonPersonalidad[3].glosa],
                        datasets: [{
                            data: [jsonPersonalidad[2].cantidad, jsonPersonalidad[3].cantidad],
                            backgroundColor: ["#58585B", "#e5e5e5"],
                        }
                        ],
                    },
                    options: optDona,
                });
                new Chart(document.getElementById("pieChart3"), {
                    plugins: [ChartDatalabels],
                    type: 'doughnut',
                    data: {
                        labels: [jsonPersonalidad[4].glosa, jsonPersonalidad[5].glosa],
                        datasets: [{
                            data: [jsonPersonalidad[4].cantidad, jsonPersonalidad[5].cantidad],
                            backgroundColor: ["#58585B", "#e5e5e5"],
                        }
                        ],

                    },
                    options: optDona,
                });
                new Chart(document.getElementById("pieChart4"), {
                    plugins: [ChartDatalabels],
                    type: 'doughnut',
                    data: {
                        labels: [jsonPersonalidad[6].glosa, jsonPersonalidad[7].glosa],
                        datasets: [{
                            data: [jsonPersonalidad[6].cantidad, jsonPersonalidad[7].cantidad],
                            backgroundColor: ["#58585B", "#e5e5e5"],
                        }
                        ],
                    },
                    options: optDona,
                });
            }
        }).catch(error => {
            //console.log(error);
        });
    }
    const backPage = () => {
        if (cont > 1) {
            setCont(1)
            window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas')
        } else {
            history.push('/s/desempleo/preparar-entrevistas')
        }
    }
    const [resultadosPartes, setresultadosPartes] = useState(false)
    const [resultadosNumeros, setresultadosNumeros] = useState(false)
    const [resultadosRazonamiento, setresultadosRazonamiento] = useState(false)
    const [resultadosPercepcion, setresultadosPercepcion] = useState(false)
    const goTest = () =>{
        document.getElementById('goTest').click();
        document.getElementById('pills-info-tab').classList.add('active')
        document.getElementById('pills-contact-tab').classList.remove('active')
    }

    return (
        <React.Fragment >
            {loaderShow && <Loader show={loaderShow} />}
            {modalShow && (<ModalFirstPsico showM={modalShow} clickClose={() => { closeModal() }} TypeRes={modalType}></ModalFirstPsico>)}
            <ContainerService tittle="Prepara entrevistas" tittleSize="34px" styleTittle={{ marginTop: "4%", fontSize: "34px" }} linkBread={linkbread}>
                <div style={{ padding: '30px 0px' }}>
                    <div className="row">
                        <div className="col-6">
                            <span className="titleMain">Pruebas psicotécnicas.</span>
                        </div>
                        {
                            cont < 3&&(
                                <div className="col-6 text-right p-0" onClick={(e) => { backPage() }}>
                                    <div className='backButtom'>
                                        <FontAwesomeIcon icon={faChevronLeft} className="chevronLeft" />
                                    </div>
                                    <button className="btn btn-defaul" style={{ color: "#949494" }}  >
                                        Volver
                                    </button>
                                </div>
                            )
                        }
                    </div>
                    <div class="p-3">
                        <ul className="nav border-bottom mt-4 pCabeceraModulo" id="pills-tab" role="tablist" >
                            <li className="nav-item" id='goTest' onClick={() => { setPruebas(true); setCont(1);window.history.pushState(null, '', '/s/desempleo/preparar-entrevistas/pruebas')}}>
                                <a style={{ width: '155px', textAlign: 'center' }} className="piscoLink nav-link active" id="pills-info-tab" data-toggle="pill" href="#pills-info" role="tab"
                                    aria-controls="pills-info" aria-selected="true" >
                                    {
                                        pruebas ?
                                            <img src={require('../../assets/img/Psico-desempleo/iconos/bancolombia-pe-003-active.svg')} alt="icono-pruebas" className="mr-3" />
                                            :
                                            <img src={require('../../assets/img/Psico-desempleo/iconos/bancolombia-pe-003-normal.svg')} alt="icono-pruebas" className="mr-3" />
                                    }
                                    Mis pruebas
                                </a>
                            </li>
                            <li className="nav-item" id="wRVeresult" onClick={() => { setPruebas(false); cargarDatosResolucion() }}>
                                <a style={{ width: '177px', textAlign: 'center' }} className=" piscoLink nav-link" id="pills-contact-tab" data-toggle="pill"
                                    href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">
                                    {
                                        !pruebas ?
                                            <img src={require('../../assets/img/Psico-desempleo/iconos/bancolombia-pe-004-active.svg')} alt="icono-pruebas" className="mr-3" />
                                            :
                                            <img src={require('../../assets/img/Psico-desempleo/iconos/bancolombia-pe-004-normal.svg')} alt="icono-pruebas" className="mr-3" />
                                    }
                                    Mis resultados
                                </a>
                            </li>
                        </ul>
                    </div>

                    <React.Fragment>
                        <div className="tab-pane fade show active" id="pills-info" role="tabpanel"
                            aria-labelledby="pills-home-tab" className={pruebas ? 'd-block' : 'd-none'}>
                            {cont === 1 && (
                                <div class="mt-3 p-3">
                                    <p>
                                        Las pruebas psicotécnicas miden tus capacidades y aptitudes profesionales, así como rasgos de personalidad. Estas permiten diagnosticar tus posibles acciones en determinadas situaciones.
                                    </p>
                                    <p>
                                        A medida que vayas completando las pruebas, podrás consultar tus resultados.
                                    </p>
                                    <div className="pad05" style={{ backgroundColor: '#F6F6F6' }}>
                                        <div className="row" >
                                            <div className="col-12">
                                                <p style={{ color: '#58585b', fontFamily: 'OpenSans-Bold', marginLeft: '12px' }}>Pruebas técnicas</p>
                                                <div className="row mb-3">

                                                    {
                                                        dataTypePsico.map((data, index) => {
                                                            return (
                                                                data.idTipoPregunta != 3 && data.idTipoPregunta != 4 ?
                                                                    <OverlayTrigger placement="bottom" overlay={popover}>
                                                                        <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 mb-3">
                                                                            <div onMouseEnter={(e) => changePop(data.idTipoPregunta)} onClick={(e) => { setCont(2); setnameTest(data);; PruebasOne(data.idTipoPregunta) }} className="contentImg" type="button">
                                                                                <div style={{ height: '50px', marginBottom: '20px', position: 'relative' }} className="col-12">
                                                                                    <img src={require('../../assets/img/Psico-desempleo/' + data.nombreTipoPregunta + '.svg')} style={{ height: '50px' }} id={'img' + index} />
                                                                                </div>
                                                                                <div className="col-12 p-0">
                                                                                    <p style={{ color: '#5E5E5E' }}>
                                                                                        Prueba de {data.nombreTipoPregunta}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                    :
                                                                    null
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <p style={{ color: '#58585b', fontFamily: 'OpenSans-Bold', marginLeft: '12px' }}>Pruebas sociales</p>
                                                <div className="row">

                                                    {
                                                        dataTypePsico.map((data, index) => {
                                                            return (
                                                                data.idTipoPregunta == 3 || data.idTipoPregunta == 4 ?
                                                                    <OverlayTrigger placement="bottom" overlay={popover}>
                                                                        <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 mb-3">
                                                                            <div onMouseEnter={(e) => changePop(data.idTipoPregunta)} onClick={(e) => { setCont(2); setnameTest(data); PruebasOne(data.idTipoPregunta) }} className="contentImg" type="button" data-toggle="tooltip" data-placement="bottom"
                                                                                title="Mide tu capacidad para dar respuesta a problemas y situaciones concretas">
                                                                                <div style={{ height: '50px', marginBottom: '20px', position: 'relative' }} className="col-12">
                                                                                    <img src={require('../../assets/img/Psico-desempleo/' + data.nombreTipoPregunta + '.svg')} style={{ height: '50px' }} id={'img' + index} />
                                                                                </div>
                                                                                <div className="col-12 p-0">
                                                                                    <p style={{ color: '#5E5E5E' }}>
                                                                                        Prueba de {data.nombreTipoPregunta}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                    :
                                                                    null
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {cont === 2 && (
                                <React.Fragment>
                                    <div className="pt-3">
                                        {
                                            <>
                                                <p style={{ color: '#58595B', fontFamily: 'OpenSans-Bold', marginLeft: '15px',fontSize:'18px' }}>
                                                    {
                                                        nameTest.nombreTipoPregunta !== 'partes'?
                                                        'Pruebas psicotécnicas - ' +nameTest.nombreTipoPregunta
                                                        :
                                                        'Prueba de ' +nameTest.nombreTipoPregunta
                                                    }
                                                </p>
                                            </>
                                        }
                                        <div class="mt-3 p-3" >
                                            {nameTest.idTipoPregunta === 1 && (
                                                <p>
                                                    Esta prueba evalúa tu capacidad de diferenciar formas, volúmenes, y posiciones en el espacio.
                                                    <br />
                                                    <br />
                                                    Trabaja cuidadosamente, debes estar seguro que comprendes el ejercicio expuesto,
                                                    al hacer click en "empezar" se iniciara la prueba. Está tiene una duración de 5 minutos.
                                                    <br />
                                                    <br />
                                                    Ejemplo prueba de partes:
                                                </p>
                                            )}
                                            {nameTest.idTipoPregunta == 2 && (
                                                <p style={{paddingRight:'6%'}}>
                                                    Esta prueba muestra tus habilidades para tareas de manejo numérico y facilidad de operar
                                                    datos cuantitativos con agilidad y precisión.
                                                    <br />
                                                    <br />
                                                    Los números dentro del recuadro resaltado corresponden a la respuesta correcta.
                                                    <br />
                                                    <br />
                                                    Ejemplo prueba numérica:
                                                </p>
                                            )}
                                            {nameTest.idTipoPregunta == 3 && (
                                                <p>
                                                    Esta prueba mide rasgos básicos de tu
                                                    personalidad, por eso no hay respuestas buenas o malas.
                                                    <br />
                                                    <br />
                                                    Podrás hacer una parte de la prueba, para realizarla completa agenda tu entrenamiento.
                                                    <br />
                                                    <br />
                                                    Esta prueba está conformada por tres secciones . Selecciona “A o B”
                                                    según corresponda, las respuestas se guardarán automáticamente.
                                                </p>
                                            )}
                                            {nameTest.idTipoPregunta == 6 && (
                                                <p>
                                                    Esta prueba mide la capacidad de atención y percepción del aspirante. Es importante que estés relajado y concentrado.
                                                    <br /><br />
                                                    Esta prueba tiene una duración máxima de 5 minutos.
                                                    <br /><br />
                                                    A continuación, está una prueba de ejemplo previa.
                                                </p>
                                            )}
                                            {nameTest.idTipoPregunta == 5 && (
                                                <p>
                                                    La prueba de razonamiento, evalúa los procesos intelectuales y cognitivos necesarios de acuerdo al cargo específico.
                                                    <br />
                                                    <br />
                                                    Debes comprender el ejercicio de ejemplo, previo a empezar la prueba. Tienes 5 minutos para completar la totalidad de la prueba.
                                                    <br />
                                                    <br />
                                                    A continuacion tienes un ejemplo de prueba:textButton
                                                </p>
                                            )}
                                            {nameTest.idTipoPregunta == 4 && (
                                                <p style={{paddingRight: '2%'}}>
                                                    Como líder enfrentarás situaciones en las que debes lograr la
                                                    cooperación de tu equipo de trabajo y/o colegas. Con esta prueba,
                                                    mide tus habilidades para ejercer el liderazgo en tu entorno.
                                                    <br />
                                                    <br />
                                                    Esta prueba está conformada por tres secciones . Selecciona “A o B”
                                                    según corresponda, las respuestas se guardarán automáticamente.
                                                </p>
                                            )}
                                        </div>
                                        <div className={nameTest.idTipoPregunta == 3 || nameTest.idTipoPregunta == 4 ? 'mt-0 row' : ' row mt-3'}>
                                            {(nameTest.idTipoPregunta != 4 && nameTest.idTipoPregunta != 6 && nameTest.idTipoPregunta != 5 && nameTest.idTipoPregunta != 3) && (
                                                <React.Fragment>
                                                    <div class="col-lg-6 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                        <table width="400px">
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px', paddingTop: '8px' }}><label class="d-block">1.</label></td>
                                                                    {nameTest.idTipoPregunta === 1 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 5 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center', padding: '0px 12px' }}>
                                                                                        <img style={{ width: '50px', borderWidth: '0px' }} class="imgPercepcion mr-1"
                                                                                            src={require('../../assets/img/img_test_psico/firstTest/' + nameTest.idTipoPregunta + '_' + (index) + '.svg')}
                                                                                            alt={'prueba' + index} />
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })
                                                                    )}{nameTest.idTipoPregunta == 2 && (
                                                                        <React.Fragment>
                                                                            <td style={{ paddingLeft: '10px', width: '30%' }}>
                                                                                <div className="containerTestsVTS font">
                                                                                    2 + 5 + 4 =
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        9
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        10
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        11
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        12
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                        </React.Fragment>
                                                                    )}
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px' }}><label class="d-block"></label></td>
                                                                    <td style={{ width: '115px' }}></td>
                                                                    {nameTest.idTipoPregunta != 3 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 4 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center' }}>
                                                                                        <input onChange={($event) => handleChangeRadio($event, nameTest.idTipoPregunta)}
                                                                                            class="form-check-input text-center radioPregunta radioPartes" type="radio"
                                                                                            name='question1' id={"repradior-partes-test" + index} value={index} style={{ marginLeft: '-8px' }}
                                                                                        />
                                                                                        <label for={"repradior-partes-test" + index}></label>
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })
                                                                    )}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="col-lg-6 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                        <table width="400px">
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px', paddingTop: '8px' }}><label class="d-block">2.</label></td>
                                                                    {nameTest.idTipoPregunta === 1 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 5 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center', padding: '0px 12px' }}>
                                                                                        <img style={{ width: '50px', borderWidth: '0px' }} class="imgPercepcion mr-1"
                                                                                            src={require('../../assets/img/img_test_psico/firstTest/' + nameTest.idTipoPregunta + '_0' + (index) + '.svg')}
                                                                                            alt={'prueba' + index} />
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })

                                                                    )}{nameTest.idTipoPregunta == 2 && (
                                                                        <React.Fragment>
                                                                            <td style={{ paddingLeft: '10px', width: '30%' }}>
                                                                                <div className="containerTestsVTS font">
                                                                                    6 + 2 - 2 =
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        6
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        7
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        8
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                                <div className="cuadroNumero">
                                                                                    <label className="form-check-label num" for="exampleRadios1">
                                                                                        9
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                        </React.Fragment>
                                                                    )}
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px' }}><label class="d-block"></label></td>
                                                                    <td style={{ width: '115px' }}></td>
                                                                    {nameTest.idTipoPregunta != 3 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 4 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center' }}>
                                                                                        <input onChange={($event) => handleChangeRadio($event, nameTest.idTipoPregunta)}
                                                                                            class="form-check-input text-center radioPregunta radioPartes" type="radio"
                                                                                            name='question2' id={"repradior-partes-test" + index} value={index} style={{ marginLeft: '-8px' }}
                                                                                        />
                                                                                        <label for={"repradior-partes-test" + index}></label>
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })

                                                                    )}

                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {nameTest.idTipoPregunta == 6 && (
                                                <React.Fragment>
                                                    <div class="col-lg-12 col-md-12 dcol-sm-12 col-xs-12 overxhid percep">
                                                        <table width="100%">
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px', paddingTop: '8px' }}><label class="d-block">1.</label></td>
                                                                    {
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 5 ?
                                                                                    <td style={{ textAlign: 'center' }}>
                                                                                        <img class="imgPercepcion mr-1" id={'imgPercepcionN' + index}
                                                                                            src={require('../../assets/img/img_test_psico/firstTest/' + nameTest.idTipoPregunta + '_' + (index) + '.png')}
                                                                                            alt={'prueba' + index} />
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px' }}><label class="d-block"></label></td>
                                                                    <td style={{ width: '115px' }}></td>
                                                                    {nameTest.idTipoPregunta != 3 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 4 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center' }}>
                                                                                        <input onChange={($event) => handleChangeRadio($event, nameTest.idTipoPregunta)}
                                                                                            class="form-check-input text-center radioPregunta radioPartes" type="radio"
                                                                                            name='question1' id={"repradior-partes-test" + index} value={index} style={{ marginLeft: '-8px' }}
                                                                                        />
                                                                                        <label for={"repradior-partes-test" + index}></label>
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })
                                                                    )}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {nameTest.idTipoPregunta == 5 && (
                                                <React.Fragment>
                                                    <div class="col-lg-12 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                        <table width="650px">
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px', paddingTop: '8px' }}><label class="d-block">1.</label></td>
                                                                    <td style={{ paddingLeft: '10px', width: '50%' }}>
                                                                        <div className="containerTestsVTS font">
                                                                            El número que sigue es: 9  10  11  12  13  14:
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                        <div className="cuadroNumero">
                                                                            <label className="form-check-label" for="exampleRadios1">
                                                                                13
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                        <div className="cuadroNumero">
                                                                            <label className="form-check-label" for="exampleRadios1">
                                                                                14
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                        <div className="cuadroNumero">
                                                                            <label className="form-check-label" for="exampleRadios1">
                                                                                15
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ paddingLeft: '1px', textAlign: 'center' }}>
                                                                        <div className="cuadroNumero">
                                                                            <label className="form-check-label" for="exampleRadios1">
                                                                                16
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ width: '8px', padding: '0px' }}><label class="d-block"></label></td>
                                                                    <td style={{ width: '115px' }}></td>
                                                                    {nameTest.idTipoPregunta != 3 && (
                                                                        dataTypePsico.map((data, index) => {
                                                                            return (
                                                                                index < 4 ?
                                                                                    <td style={{ width: '115px', textAlign: 'center' }}>
                                                                                        <input onChange={($event) => handleChangeRadio($event, nameTest.idTipoPregunta)}
                                                                                            class="form-check-input text-center radioPregunta radioPartes" type="radio"
                                                                                            name='question1' id={"repradior-partes-test" + index} value={index} style={{ marginLeft: '-8px' }}
                                                                                        />
                                                                                        <label for={"repradior-partes-test" + index}></label>
                                                                                    </td>
                                                                                    :
                                                                                    null
                                                                            )
                                                                        })
                                                                    )}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        <React.Fragment>
                                            <div className={nameTest.idTipoPregunta == 3 || nameTest.idTipoPregunta == 4 ? 'mt-0 text-center' : ' text-center mt-5'}>
                                                <button className="btnMainBluePsico" style={{textTransform:'uppercase'}} onClick={() => getQuestionsComplete(nameTest.idTipoPregunta)}>
                                                    Empezar 
                                                </button>
                                            </div>
                                        </React.Fragment>
                                    </div>
                                </React.Fragment>
                            )}{cont === 3 && (
                                <React.Fragment>
                                    <div className="pt-3">
                                        {
                                            <p style={{ color: '#58595B', fontFamily: 'OpenSans-Bold', marginLeft: '15px',fontSize:'18px' }}>
                                                {
                                                    nameTest.nombreTipoPregunta !== 'partes'?
                                                    'Pruebas psicotécnicas - ' +nameTest.nombreTipoPregunta
                                                    :
                                                    'Prueba de ' +nameTest.nombreTipoPregunta
                                                }
                                            </p>
                                        }
                                        {nameTest.idTipoPregunta === 1 && (
                                            <p className="p-3 mb-5">
                                                Selecciona la opción cuyas partes coincidan con la figura principal:
                                            </p>
                                        )}
                                        {nameTest.idTipoPregunta == 2 && (
                                            <p className="p-3 mb-5">
                                                Realiza el cálculo de la operación numérica que se expone y selecciona la respuesta correcta.
                                            </p>
                                        )}
                                        {nameTest.idTipoPregunta == 3 && (
                                            <p className="p-3 mb-5">
                                                Esta prueba está conformada por tres secciones . Selecciona “A o B” según corresponda,
                                                las respuestas se guardarán automáticamente.
                                            </p>
                                        )}
                                        {nameTest.idTipoPregunta == 4 && (
                                            <p className="p-3 mb-5">
                                                Esta prueba está conformada por tres secciones . Selecciona “A o B” según corresponda, las respuestas se guardarán automáticamente.
                                            </p>
                                        )}
                                        {nameTest.idTipoPregunta == 5 && (
                                            <p className="p-3 mb-5">
                                                Realiza el cálculo de la operación numérica que se expone y selecciona la respuesta correcta.
                                            </p>
                                        )}
                                        {nameTest.idTipoPregunta == 6 && (
                                            <p className="p-3 mb-5 " id="pr4Text">
                                                Esta prueba mide la atención y la capacidad de concentración. Debes estar atento y elegir la respuesta que consideres correcta.
                                            </p>
                                        )}

                                        <div className="row">
                                            {nameTest.idTipoPregunta === 1 && (
                                                dataQuestions.map((data, index) => {
                                                    return (
                                                        <div className="col-lg-6 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                            <div className="form-group">
                                                                <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                <table>
                                                                    <tr>
                                                                        <td style={{ verticalAlign: 'middle', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            <label className="d-block">
                                                                                {index + 1}.
                                                                            </label>
                                                                        </td>
                                                                        <td style={{ paddingLeft: '15px', textAlign: 'center' }}>
                                                                            <img
                                                                                className="imgPartes"
                                                                                src={require('../../assets/img/img_test_psico/partes/' + data.glosaPregunta)} alt=""
                                                                                style={{ width: '50px', border: '3px solid black' }} />
                                                                        </td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingLeft: '25px', textAlign: 'center' }} >
                                                                                        <img style={{ width: '50px', border: '3px solid black' }}
                                                                                            className="imgPartes"
                                                                                            src={require('../../assets/img/img_test_psico/partes/' + item.glosaPreguntaRespuesta)} alt="" />
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingLeft: '12px', paddingTop: '10px', textAlign: 'center' }} >
                                                                                        <input className="form-check-input text-center radioPregunta radioPartes"
                                                                                            type="radio" name={'radio-' + item.idPregunta} style={{ margin: '0 auto' }}
                                                                                            id={'repradior-' + item.idPreguntaRespuesta} />
                                                                                        <label style={{ marginLeft: '1px' }}
                                                                                            for={'repradior-' + item.idPreguntaRespuesta}>
                                                                                        </label>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                            {nameTest.idTipoPregunta === 2 && (
                                                dataQuestions.map((data, index) => {
                                                    return (
                                                        <div className="col-lg-6 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                            <div className="form-group">
                                                                <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                <table>
                                                                    <tr>
                                                                        <td style={{ verticalAlign: 'middle', fontWeight: 'bold', textAlign: 'center', paddingTop: '8px' }}>
                                                                            <label className="d-block">
                                                                                {index + 1}.
                                                                            </label>
                                                                        </td>
                                                                        <td style={{ paddingLeft: '15px', textAlign: 'center', width: '135px' }}>
                                                                            <div class="containerTestsVTS font" style={{ width: '100%' }}>
                                                                                {data.glosaPregunta} =
                                                                            </div>
                                                                        </td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ textAlign: 'center', width: '70px' }} >
                                                                                        <div className="cuadroNumero">
                                                                                            <label id={'lbl-' + item.idPreguntaRespuesta}>
                                                                                                {item.glosaPreguntaRespuesta}
                                                                                            </label>
                                                                                        </div>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingTop: '10px', textAlign: 'center' }} >
                                                                                        <input className="form-check-input text-center radioPregunta radioPartes"
                                                                                            type="radio" name={'radio-' + item.idPregunta} style={{ margin: '0 auto', marginLeft: '-5px' }}
                                                                                            id={'repradior-' + item.idPreguntaRespuesta} value={item.idPreguntaRespuesta} />
                                                                                        <label style={{ marginLeft: '1px' }}
                                                                                            for={'repradior-' + item.idPreguntaRespuesta}>
                                                                                        </label>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                            {nameTest.idTipoPregunta === 3 && (
                                                <div class="card-body">
                                                    <ul class="nav unic nav-tabs mb-5" style={{ display: 'flex', }} id="custom-content-below-tab"
                                                        role="tablist">
                                                        <li class="nav-item">
                                                            <a onClick={() => { backStep(1) }} style={{ width: '177px', textAlign: 'center' }} className="piscoLink seccion nav-link active" id="custom-content-below-home-tab"
                                                                data-toggle="pill" href="#custom-content-below-home" role="tab"
                                                                aria-controls="custom-content-below-home" aria-selected="true">
                                                                Sección uno
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a onClick={() => { backStep(2) }} style={{ width: '177px', textAlign: 'center' }} className="piscoLink seccion nav-link" id="custom-content-below-profile-tab"
                                                                data-toggle="pill" href="#custom-content-below-profile" role="tab"
                                                                aria-controls="custom-content-below-profile" aria-selected="false">
                                                                Sección dos
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a onClick={() => { backStep(3) }} style={{ width: '177px', textAlign: 'center' }} className="piscoLink seccion nav-link" id="custom-content-below-messages-tab"
                                                                data-toggle="pill" href="#custom-content-below-messages" role="tab"
                                                                aria-controls="custom-content-below-messages" aria-selected="false">
                                                                Sección tres
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div class="tab-content" id="custom-content-below-tabContent">
                                                        <div class="tab-pane fade show active" id="custom-content-below-home" role="tabpanel"
                                                            aria-labelledby="custom-content-below-home-tab">
                                                            <div class="row" style={{ marginTop: '25px' }}>
                                                                {
                                                                    dataQuestions.map((data, index) => {

                                                                        return (
                                                                            <div className={data.numeroPagina == 1 ? 'd-block col-md-6 col-xs-12 mb-5 overxhid' : 'd-none'}>
                                                                                <div className="form-group">
                                                                                    <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                                    <label class="d-block" for="typeId">
                                                                                        {data.IdPregunta - 94} .  {data.glosaPregunta}
                                                                                    </label>
                                                                                    <div style={{ padding: '10px 30px' }}>
                                                                                        {
                                                                                            data.Data.map(item => {
                                                                                                return (
                                                                                                    <div class="form-check mt-2">
                                                                                                        <span style={{ display: 'inline' }} >
                                                                                                            <input type="radio" name={'radio-' + item.idPregunta}
                                                                                                                id={'repradior-' + item.idPreguntaRespuesta} class="form-check-input"
                                                                                                                value={item.idPreguntaRespuesta} />
                                                                                                            <label for={'repradior-' + item.idPreguntaRespuesta} class="form-check-label">
                                                                                                                <strong class={item.orden == 1 ? 'd-inline' : 'd-none'}>  A.  </strong>
                                                                                                                <strong class={item.orden == 2 ? 'd-inline' : 'd-none'}>  B.  </strong>
                                                                                                                <strong class={item.orden == 3 ? 'd-inline' : 'd-none'}>  C.  </strong>
                                                                                                                <span class="inline">
                                                                                                                    {item.glosaPreguntaRespuesta}
                                                                                                                </span>
                                                                                                            </label>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="tab-pane fade d-block" id="custom-content-below-profile" role="tabpanel"
                                                            aria-labelledby="custom-content-below-profile-tab">
                                                                <p style={{    fontFamily: 'OpenSans-Bold',color: '#58595b'}}>
                                                                    ¿Cuál palabra en cada pareja de palabras te gusta más? Piensa en el significado de las palabras, y no en su aspecto o sonido
                                                                </p>
                                                            <div class="row" style={{ marginTop: '25px' }}>
                                                                {
                                                                    dataQuestions.map((data, index) => {
                                                                        return (
                                                                            <div className={data.numeroPagina == 2 ? 'd-block col-md-6 col-xs-12 mb-5' : 'd-none'}>
                                                                                <div className="form-group">
                                                                                    <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                                    <label class="d-block" for="typeId">
                                                                                        {data.IdPregunta - 94} .  {data.glosaPregunta}
                                                                                    </label>
                                                                                    <div style={{ padding: '10px 30px' }}>
                                                                                        {
                                                                                            data.Data.map(item => {
                                                                                                return (
                                                                                                    <div class="form-check mt-2">
                                                                                                        <span style={{ display: 'inline' }} >
                                                                                                            <input type="radio" name={'radio-' + item.idPregunta}
                                                                                                                id={'repradior-' + item.idPreguntaRespuesta} class="form-check-input"
                                                                                                                value={item.idPreguntaRespuesta} />
                                                                                                            <label for={'repradior-' + item.idPreguntaRespuesta} class="form-check-label">
                                                                                                                <strong class={item.orden == 1 ? 'd-inline' : 'd-none'}>  A.  </strong>
                                                                                                                <strong class={item.orden == 2 ? 'd-inline' : 'd-none'}>  B.  </strong>
                                                                                                                <strong class={item.orden == 3 ? 'd-inline' : 'd-none'}>  C.  </strong>
                                                                                                                <span class="inline">
                                                                                                                    {item.glosaPreguntaRespuesta}
                                                                                                                </span>
                                                                                                            </label>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="tab-pane fade" id="custom-content-below-messages" role="tabpanel"
                                                            aria-labelledby="custom-content-below-messages-tab">
                                                            <div class="row" style={{ marginTop: '25px' }}>
                                                                {
                                                                    dataQuestions.map((data, index) => {
                                                                        return (
                                                                            <div className={data.numeroPagina == 3 ? 'd-block col-md-6 col-xs-12 mb-5' : 'd-none'}>
                                                                                <div className="form-group">
                                                                                    <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                                    <label class="d-inline" for="typeId">
                                                                                        {data.IdPregunta - 94} .  {data.glosaPregunta}
                                                                                    </label>
                                                                                    <div style={{ padding: '10px 30px' }}>
                                                                                        {
                                                                                            data.Data.map(item => {
                                                                                                return (
                                                                                                    <div class="form-check mt-2">
                                                                                                        <span style={{ display: 'inline' }} >
                                                                                                            <input type="radio" name={'radio-' + item.idPregunta}
                                                                                                                id={'repradior-' + item.idPreguntaRespuesta} class="form-check-input"
                                                                                                                value={item.idPreguntaRespuesta} />
                                                                                                            <label for={'repradior-' + item.idPreguntaRespuesta} class="form-check-label">
                                                                                                                <strong class={item.orden == 1 ? 'd-inline' : 'd-none'}>  A.  </strong>
                                                                                                                <strong class={item.orden == 2 ? 'd-inline' : 'd-none'}>  B.  </strong>
                                                                                                                <strong class={item.orden == 3 ? 'd-inline' : 'd-none'}>  C.  </strong>
                                                                                                                <span class="inline">
                                                                                                                    {item.glosaPreguntaRespuesta}
                                                                                                                </span>
                                                                                                            </label>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {nameTest.idTipoPregunta === 4 && (
                                                dataQuestions.map((data, index) => {
                                                    return (
                                                        <div className="col-lg-6 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                            <div className="form-group">
                                                                <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                <label class="d-block" for="typeId">
                                                                    {index + 1}.  {data.glosaPregunta}
                                                                </label>
                                                                {
                                                                    data.Data.map(item => {
                                                                        return (
                                                                            <div class="form-check mt-2">
                                                                                <span style={{ display: 'inline' }} >
                                                                                    <input type="radio" name={'radio-' + item.idPregunta}
                                                                                        id={'repradior-' + item.idPreguntaRespuesta} class="form-check-input"
                                                                                        value={item.idPreguntaRespuesta} />
                                                                                    <label for={'repradior-' + item.idPreguntaRespuesta} class="form-check-label">
                                                                                        <strong class={item.orden == 1 ? 'd-inline' : 'd-none'}> A </strong>
                                                                                        <strong class={item.orden == 2 ? 'd-inline' : 'd-none'}> B </strong>
                                                                                        <strong class={item.orden == 3 ? 'd-inline' : 'd-none'}> C </strong>
                                                                                        <span class="inline">
                                                                                            {item.glosaPreguntaRespuesta}
                                                                                        </span>
                                                                                    </label>
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                            {nameTest.idTipoPregunta === 5 && (
                                                dataQuestions.map((data, index) => {
                                                    return (
                                                        <div className="col-lg-12 col-md-12 dcol-sm-12 col-xs-12 overxhid">
                                                            <div className="form-group">
                                                                <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                <table width="750px">
                                                                    <tr>
                                                                        <td style={{ verticalAlign: 'middle', fontWeight: 'bold', textAlign: 'left', paddingTop: '8px', width: '8px' }}>
                                                                            <label className="d-block">
                                                                                {index + 1}.
                                                                            </label>
                                                                        </td>
                                                                        <td style={{ paddingLeft: '15px', textAlign: 'left', width: '50%' }}>
                                                                            <div class="containerTestsVTS font" style={{ width: '100%' }}>
                                                                                {data.glosaPregunta}:
                                                                            </div>
                                                                        </td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ textAlign: 'center', width: '70px' }} >
                                                                                        <div className="cuadroNumero">
                                                                                            <label id={'lbl-' + item.idPreguntaRespuesta}>
                                                                                                {item.glosaPreguntaRespuesta}
                                                                                            </label>
                                                                                        </div>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingTop: '10px', textAlign: 'center' }} >
                                                                                        <input className="form-check-input text-center radioPregunta radioPartes"
                                                                                            type="radio" name={'radio-' + item.idPregunta} style={{ margin: '0 auto', marginLeft: '-5px' }}
                                                                                            id={'repradior-' + item.idPreguntaRespuesta} value={item.idPreguntaRespuesta} />
                                                                                        <label style={{ marginLeft: '1px' }}
                                                                                            for={'repradior-' + item.idPreguntaRespuesta}>
                                                                                        </label>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                            {nameTest.idTipoPregunta === 6 && (
                                                dataQuestions.map((data, index) => {
                                                    return (
                                                        <div className="col-lg-12 col-md-12 dcol-sm-12 col-xs-12 overxhid percep">
                                                            <div className="form-group">
                                                                <input type="hidden" id={'hddn-' + data.IdPregunta} className="grupoPregunta" />
                                                                <table>
                                                                    <tr>
                                                                        <td style={{ verticalAlign: 'middle', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            <label className="d-block">
                                                                                {index + 1}.
                                                                            </label>
                                                                        </td>
                                                                        <td style={{ paddingLeft: '15px', textAlign: 'center' }}>
                                                                            <img className="imgPartes" src={require('../../assets/img/img_test_psico/percepcion/' + data.glosaPregunta)} alt="" />
                                                                        </td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingLeft: '25px', textAlign: 'center' }} >
                                                                                        <img
                                                                                            className="imgPercepcion mr-1"
                                                                                            src={require('../../assets/img/img_test_psico/percepcion/' + item.glosaPreguntaRespuesta)} alt="" />
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        {
                                                                            data.Data.map(item => {
                                                                                return (
                                                                                    <td style={{ paddingLeft: '12px', paddingTop: '10px', textAlign: 'center' }} >
                                                                                        <input className="form-check-input text-center radioPregunta radioPartes"
                                                                                            type="radio" name={'radio-' + item.idPregunta} style={{ margin: '0 auto' }}
                                                                                            id={'repradior-' + item.idPreguntaRespuesta} />
                                                                                        <label style={{ marginLeft: '1px' }}
                                                                                            for={'repradior-' + item.idPreguntaRespuesta}>
                                                                                        </label>
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                        </div>
                                    </div>
                                    {/* className={!isSimulation && !submitted && step == 0? 'd-none btnMain mb-3' : 'd-block btnMain mb-3'} */}
                                    <React.Fragment>
                                        {((step == 2 || step == 1) && gestion) && (
                                            <div className="text-center">
                                                <button
                                                    className="btnMainBluePsico mb-3" style={{textTransform:'uppercase'}} onClick={() => { goStep() }}>Continuar
                                                </button>
                                            </div>
                                        )}
                                        {(step == 0) && (

                                            <div className="text-center">
                                                <button className="btnMainBluePsico mb-3" style={{textTransform:'uppercase'}} onClick={() => { saveData() }}>
                                                    Finalizar
                                                </button>
                                            </div>
                                        )}
                                    </React.Fragment>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="tab-pane fade " id="pills-contact" role="tabpanel"
                            aria-labelledby="pills-contact-tab" className={!pruebas ? 'd-block' : 'd-none'}>
                            <div className='m-3'>
                                <p className='mt-5'>
                                    Aquí encuentras los resultados de tus pruebas.
                                </p>

                                <canvas id="areaChart" width="400" height="200" style={{ border: '1px solid #d9d9d9', marginTop: '30px' }} class="chartjs-render-monitor">
                                </canvas>
                                <div class="col-lg-12">
                                    <h5 style={{ fontFamily: 'cibSans-Bold', color: '#58595B', fontWeight: 'bold' }} class="mt-5">Resultados pruebas técnicas</h5>
                                    <div class="row">

                                        <div class="col-lg-6 col-xs-12 mt-5">
                                            <div class="card divResultado resPartes">
                                                <p style={{ color: '#fff', fontFamily: 'cibSans-Bold', fontWeight: 'bold', fontSize: '22px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" style={{ marginRight: '10px' }}
                                                        viewBox="0 0 23 23">
                                                        <g fill="#FFF" fill-rule="evenodd">
                                                            <path
                                                                d="M13.935 11.713l6.75 4.726a9.015 9.015 0 0 0 1.491-4.726h-8.24zm6.822 5.391a.277.277 0 0 1-.16-.05l-7.701-5.391a.277.277 0 0 1 .16-.504h9.403c.153 0 .276.124.276.277a9.575 9.575 0 0 1-1.752 5.55.277.277 0 0 1-.226.118zM12.368 9.713h8.844c-.144-4.813-4.032-8.7-8.844-8.845v8.845zm9.125.554h-9.402a.278.278 0 0 1-.277-.277V.587c0-.153.124-.278.277-.278 5.338 0 9.68 4.343 9.68 9.68a.278.278 0 0 1-.278.278z" />
                                                            <path
                                                                d="M10.367 2.314c-4.904.148-8.848 4.184-8.848 9.122a9.05 9.05 0 0 0 .933 4.025 9.15 9.15 0 0 0 3.74 3.942 9.247 9.247 0 0 0 6.695.88 9.119 9.119 0 0 0 1.657-.594 9.192 9.192 0 0 0 3.412-2.796l-7.47-5.23a.278.278 0 0 1-.12-.227V2.314zm.276 18.802a9.688 9.688 0 0 1-4.722-1.229 9.701 9.701 0 0 1-3.966-4.18 9.584 9.584 0 0 1-.991-4.27c0-5.34 4.343-9.68 9.68-9.68.153 0 .277.123.277.277v9.257l7.583 5.309a.276.276 0 0 1 .067.387 9.698 9.698 0 0 1-3.791 3.203 9.609 9.609 0 0 1-4.137.926z" />
                                                            <path
                                                                d="M9.68 22.563a9.67 9.67 0 0 1-7.021-3.017A9.678 9.678 0 0 1 .99 17.153a9.59 9.59 0 0 1-.99-4.27c0-1.725 0-5.762 5.18-9.389a.277.277 0 1 1 .318.454C.555 7.409.555 11.106.555 12.883c0 1.412.313 2.768.932 4.025a9.16 9.16 0 0 0 3.74 3.942 9.25 9.25 0 0 0 6.694.881 9.155 9.155 0 0 0 1.657-.595 9.158 9.158 0 0 0 1.494-.89c.766-.563 2.422-2.752 3.06-3.665a.278.278 0 0 1 .454.319c-.541.775-2.29 3.134-3.186 3.792a9.672 9.672 0 0 1-5.72 1.871" />
                                                        </g>
                                                    </svg>

                                                    Partes
                                                </p>
                                                <div style={{ display: 'inline-block' }}>
                                                    <div className="TextPart">
                                                        <span>
                                                            Capacidad para dar respuestas a problemas
                                                            y situaciones concretas.
                                                    </span>
                                                    </div>
                                                    <div >
                                                        <button onClick={() => { setresultadosPartes(!resultadosPartes) }} class="btn-psico-resultados btn-defaul"
                                                            style={{ float: 'right' }}>
                                                            {!resultadosPartes && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_1.png")} alt="" />
                                                            )}
                                                            {resultadosPartes && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_2.png")} alt="" />
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="card mt-2 " style={{ backgroundColor: '#F6F8FA' }}>
                                                <div class="row mb-3 divDetalleResultado" >
                                                    <div class="col-4 bdRG text-center">
                                                        {Partes_buenas_}<br />Aciertos
                                                </div>
                                                    <div class="col-4 bdRG text-center">
                                                        {Partes_malas_}<br />Errores
                                                </div>
                                                    <div class="col-4  text-center">
                                                        0<br />Omisiones
                                                </div>
                                                </div>
                                                <div >
                                                    {resultadosPartes && (
                                                        <div class="textAnswer">
                                                            <div>
                                                                <span>{Partes_}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-lg-6 col-xs-12 mt-5">
                                            <div class="card divResultado resNumeros">
                                                <p style={{ color: '#fff', fontFamily: 'cibSans-Bold', fontWeight: 'bold', fontSize: '22px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" style={{ marginRight: '10px' }}
                                                        viewBox="0 0 19 20">
                                                        <g fill="#FFF" fill-rule="evenodd">
                                                            <path
                                                                d="M16.662 19.148h-1.42a.238.238 0 1 1 0-.478h1.42c.946 0 1.716-.774 1.716-1.724V2.202c0-.95-.77-1.725-1.716-1.725H3.142c-.947 0-1.717.774-1.717 1.725v14.744c0 .95.77 1.724 1.717 1.724h8.927c.13 0 .237.108.237.239 0 .133-.106.24-.237.24H3.142A2.2 2.2 0 0 1 .95 16.945V2.202A2.2 2.2 0 0 1 3.142 0h13.52c1.208 0 2.19.987 2.19 2.202v14.744a2.2 2.2 0 0 1-2.19 2.202" />
                                                            <path
                                                                d="M15.237 19.148h-1.421a.238.238 0 0 1-.237-.24c0-.13.106-.238.237-.238h1.421c.131 0 .237.108.237.239 0 .133-.106.24-.237.24M3.758 19.148H2.192A2.2 2.2 0 0 1 0 16.946V2.202A2.2 2.2 0 0 1 2.192 0h1.804a.238.238 0 0 1 0 .477H2.192C1.245.477.476 1.25.476 2.202v14.744c0 .95.77 1.724 1.716 1.724h1.566a.238.238 0 0 1 0 .478" />
                                                            <path
                                                                d="M3.813 10.195h1.54V8.648h-1.54v1.547zm1.633.478H3.72a.385.385 0 0 1-.383-.384V8.554c0-.21.172-.384.383-.384h1.726c.21 0 .382.173.382.384v1.735a.385.385 0 0 1-.382.384zM7.255 10.195h1.54V8.648h-1.54v1.547zm1.633.478H7.162a.385.385 0 0 1-.382-.384V8.554c0-.21.172-.384.382-.384h1.726c.21 0 .382.173.382.384v1.735a.384.384 0 0 1-.382.384zM4.208 17.08c.071.017.19.034.347.034h6.94c.158 0 .276-.017.347-.034v-1.481a1.57 1.57 0 0 0-.347-.033h-6.94c-.157 0-.276.016-.347.033v1.481zm7.287.511h-6.94c-.375 0-.822-.066-.822-.385v-1.733c0-.318.447-.385.822-.385h6.94c.375 0 .822.067.822.385v1.733c0 .32-.447.385-.822.385zM10.697 10.195h1.54V8.648h-1.54v1.547zm1.633.478h-1.725a.385.385 0 0 1-.383-.384V8.554c0-.21.172-.384.383-.384h1.725c.212 0 .383.173.383.384v1.735a.384.384 0 0 1-.383.384zM14.14 10.195h1.54V8.648h-1.54v1.547zm1.633.478h-1.725a.384.384 0 0 1-.383-.384V8.554c0-.21.171-.384.383-.384h1.725c.211 0 .382.173.382.384v1.735a.384.384 0 0 1-.382.384zM3.813 13.654h1.54v-1.547h-1.54v1.547zm1.633.478H3.72a.384.384 0 0 1-.383-.384v-1.734c0-.212.172-.385.383-.385h1.726c.21 0 .382.173.382.385v1.734a.384.384 0 0 1-.382.384zM7.255 13.654h1.54v-1.547h-1.54v1.547zm1.633.478H7.162a.384.384 0 0 1-.382-.384v-1.734c0-.212.172-.385.382-.385h1.726c.21 0 .382.173.382.385v1.734a.383.383 0 0 1-.382.384zM10.697 13.654h1.54v-1.547h-1.54v1.547zm1.633.478h-1.725a.384.384 0 0 1-.383-.384v-1.734c0-.212.172-.385.383-.385h1.725c.212 0 .383.173.383.385v1.734a.384.384 0 0 1-.383.384zM14.14 13.654h1.54v-1.547h-1.54v1.547zm1.633.478h-1.725a.383.383 0 0 1-.383-.384v-1.734c0-.212.171-.385.383-.385h1.725c.211 0 .382.173.382.385v1.734a.383.383 0 0 1-.382.384zM14.14 17.114h1.54v-1.548h-1.54v1.548zm1.633.477h-1.725a.384.384 0 0 1-.383-.385v-1.733c0-.212.171-.384.383-.384h1.725c.211 0 .382.172.382.384v1.733a.384.384 0 0 1-.382.385zM15.06 2.352H4.255a1.03 1.03 0 0 0-1.028 1.032v1.974c0 .57.46 1.031 1.028 1.031h10.807a1.03 1.03 0 0 0 1.027-1.031V3.384c0-.57-.46-1.032-1.027-1.032" />
                                                        </g>
                                                    </svg>
                                                Números
                                            </p>
                                                <div style={{ display: 'inline-block' }}>
                                                    <div className="TextNum" >
                                                        <span>
                                                            Prueba de habilidad para ejecutar operaciones numerica
                                                    </span>
                                                    </div>
                                                    <div >
                                                        <button onClick={() => { setresultadosNumeros(!resultadosNumeros) }} class="btn-psico-resultados btn-defaul"
                                                            style={{ float: 'right' }}>
                                                            {!resultadosNumeros && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_1.png")} alt="" />
                                                            )}
                                                            {resultadosNumeros && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_2.png")} alt="" />
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="card mt-2 " style={{ backgroundColor: '#F6F8FA' }}>
                                                <div class="row mb-3 divDetalleResultado">
                                                    <div class="col-4 bdRG text-center" >
                                                        {Numeros_buenas_}<br />Aciertos
                                          </div>
                                                    <div class="col-4 bdRG text-center" >
                                                        {Numeros_malas_}<br />Errores
                                          </div>
                                                    <div class="col-4 text-center">
                                                        0<br />Omisiones
                                          </div>
                                                </div>
                                                <div >
                                                    {resultadosNumeros && (
                                                        <div class="textAnswer">
                                                            <div>
                                                                <span>{Numeros_}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xs-12 mt-5">
                                            <div class="card divResultado resRazonamiento">
                                                <p style={{ color: '#fff', fontFamily: 'cibSans-Bold', fontWeight: 'bold', fontSize: '22px' }}>
                                                    <img style={{ width: '23px', height: '23px', marginRight: '10px' }} src={require('../../assets/img/img_test_psico/resultado/razonamientoR.svg')} alt="Razonamiento" />
                                                Razonamiento
                                            </p>
                                                <div style={{ display: 'inline-block' }}>
                                                    <div className="TextRaz">
                                                        <span>
                                                            Prueba de habilidad para reconocer y seguir relaciones.
                                                    </span>
                                                    </div>
                                                    <div >
                                                        <button onClick={() => { setresultadosRazonamiento(!resultadosRazonamiento) }} class="btn-psico-resultados btn-defaul"
                                                            style={{ float: 'right' }}>
                                                            {!resultadosRazonamiento && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_1.png")} alt="" />
                                                            )}
                                                            {resultadosRazonamiento && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_2.png")} alt="" />
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="card mt-2 " style={{ backgroundColor: '#F6F8FA' }}>
                                                <div class="row mb-3 divDetalleResultado">
                                                    <div class="col-4 bdRG text-center" >
                                                        {Razonamiento_buenas_}<br />Aciertos
                                          </div>
                                                    <div class="col-4 bdRG text-center" >
                                                        {Razonamiento_malas_}<br />Errores
                                          </div>
                                                    <div class="col-4   text-center">
                                                        0<br />Omisiones
                                          </div>
                                                </div>
                                                <div >
                                                    {resultadosRazonamiento && (
                                                        <div class="textAnswer">
                                                            <div>
                                                                <span>{Razonamiento_}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xs-12 mt-5">
                                            <div class="card divResultado resPersepcion">
                                                <p style={{ color: '#fff', fontFamily: 'cibSans-Bold', fontWeight: 'bold', fontSize: '22px' }}>
                                                    <img style={{ width: '23px', height: '23px', marginRight: '10px' }}
                                                        src={require('../../assets/img/img_test_psico/resultado/percepcionR.svg')} alt="Percepción" />
                                                Percepción
                                            </p>
                                                <div style={{ display: 'inline-block' }}>
                                                    <div style={{ width: '80%', float: 'left' }}>
                                                        <span>
                                                            Capacidad para percibir similitudes y
                                                            diferencias en textos y números
                                                    </span>
                                                    </div>
                                                    <div >
                                                        <button onClick={() => { setresultadosPercepcion(!resultadosPercepcion) }} class="btn-psico-resultados btn-defaul"
                                                            style={{ float: 'right' }}>
                                                            {!resultadosPercepcion && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_1.png")} alt="" />
                                                            )}
                                                            {resultadosPercepcion && (
                                                                <img style={{ width: '35px' }}
                                                                    src={require("../../assets/img/img_test_psico/resultado/mok-scotia-botones-psico_2.png")} alt="" />
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="card mt-2 " style={{ backgroundColor: '#F6F8FA' }}>
                                                <div class="row mb-3 divDetalleResultado">
                                                    <div class="col-4 bdRG text-center" >
                                                        {Percepcion_buenas_}<br />Aciertos
                                          </div>
                                                    <div class="col-4 bdRG text-center" >
                                                        {Percepcion_malas_}<br />Errores
                                          </div>
                                                    <div class="col-4 text-center">
                                                        0<br />Omisiones
                                          </div>
                                                </div>
                                                <div >
                                                    {resultadosPercepcion && (
                                                        <div class="textAnswer">
                                                            <div>
                                                                <span>{Percepcion_}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <h5 style={{ fontFamily: 'cibSans-Bold', color: '#58595B', fontWeight: 'bold' }} class="mt-5 mb-4">
                                        Resultados pruebas sociales
                                    </h5>
                                    <p>
                                    Los siguientes resultados determinan tus habilidades de liderazgo en entornos de cooperación y trabajo en equipo. 
                                    </p>
                                    <canvas id="barChart" width="400" max-height="200" style={{ border: '1px solid #d9d9d9', marginTop: '30px' }}>

                                    </canvas>
                                </div>
                                <div class="col-lg-12 mt-5">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-6" style={{padding:'0px 25px'}}><canvas id="pieChart1" width="208"
                                            height="298" style={{ border: '1px solid #d9d9d9' }}></canvas>
                                        </div>
                                        <div class="col-lg-3 col-md-6" style={{padding:'0px 25px'}}><canvas id="pieChart2" width="208"
                                            height="298" style={{ border: '1px solid #d9d9d9' }}></canvas>
                                        </div>
                                        <div class="col-lg-3 col-md-6" style={{padding:'0px 25px'}}><canvas id="pieChart3" width="208"
                                            height="298" style={{ border: '1px solid #d9d9d9' }}></canvas>
                                        </div>
                                        <div class="col-lg-3 col-md-6" style={{padding:'0px 25px'}}><canvas id="pieChart4" width="208"
                                            height="298" style={{ border: '1px solid #d9d9d9' }}></canvas>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mb-5 mt-5">
                                    <button className="btnMainBluePsico mb-5 mt-3" style={{width: '300px',textTransform: 'uppercase'}} 
                                    onClick={() => { goTest() }}>
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>


                </div>
            </ContainerService>
        </React.Fragment>
    )
}